import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {isPOS, onTSP, KTIcon} from '../../../../../../_metronic/helpers'
import {useAuth} from '../../../../auth'
import {useListView} from '../core/ListViewProvider'
import {SearchSelectOption} from '../../../../../../_metronic/helpers/components/SearchSelect'
import './InvoiceEditModalHeader.css'
import {
  FieldHelpIcon,
  FieldHelpLabel,
} from '../../../../../../_metronic/helpers/components/FieldHelp'
import {isOnPremisesInstallation} from '../../../../auth/core/onPremisesAccess'
import {useCostFormAccess} from './CostFormServiceGate'
import {useCurrentBusiness} from '../../../shared/business-switcher/useCurrentBusiness'

type props = {
  title: string
  closeFn?: () => void
  formType: {
    formType: number
    setFormType: Dispatch<SetStateAction<number>>
  }
  /** The edited invoice can only use the full form: no form choice is offered for it. */
  lockedFullForm?: boolean
}
const InvoiceEditModalHeader: FC<props> = ({
  title,
  closeFn,
  formType: _formType,
  lockedFullForm = false,
}) => {
  const {setItemIdForUpdate, setvariableD, variableD} = useListView()
  const {currentUser} = useAuth()
  const currentCompany = currentUser?.cpl?.find((x) => x.id === currentUser.cpi)
  // The business the invoice is issued in, with its label (two branches share a name).
  const currentBusiness = useCurrentBusiness()
  const [first, setFirst] = useState(true)
  const hasFixedFullForm =
    variableD === 4 || variableD === 5 || isOnPremisesInstallation(currentUser)
  const [formType, setFormType] = useState(hasFixedFullForm ? 0 : _formType.formType)

  const [formItems, setFormItems] = useState<SearchSelectOption[]>()
  const costFormAccess = useCostFormAccess()
  const isSelectingInvoiceType = !title || title === 'نوع صورتحساب را انتخاب کنید'

  useEffect(() => {
    if (first) {
      let form: SearchSelectOption[] = []

      if (currentCompany && currentCompany.frm && currentCompany.frm.length > 0) {
        currentCompany.frm.forEach((x) => {
          switch (x) {
            case 0:
              if (!isPOS) {
                form.push({
                  label: 'فرم کامل',
                  value: 0,
                })
              }
              break
            case 1:
              form.push({
                label: 'فرم ساده',
                value: 1,
              })
              break
            case 2:
              if (!onTSP) {
                form.push({
                  label: 'فرم قیمت تمام شده',
                  value: 2,
                })
              }
              break
            case 3:
              if (!onTSP) {
                form.push({
                  label: 'فرم قیمت تمام شده پیشرفته',
                  value: 3,
                })
              }
              break
          }
        })
        if (
          !onTSP &&
          currentCompany.frm.includes(2) &&
          form.findIndex((item) => item.value === 3) < 0
        ) {
          form.push({
            label: 'فرم قیمت تمام شده پیشرفته',
            value: 3,
          })
        }
      } else {
        if (!isPOS) {
          form.push({
            label: 'فرم کامل',
            value: 0,
          })
        }
        form.push({
          label: 'فرم ساده',
          value: 1,
        })
        if (!onTSP) {
          form.push({
            label: 'فرم قیمت تمام شده',
            value: 2,
          })
          form.push({
            label: 'فرم قیمت تمام شده پیشرفته',
            value: 3,
          })
        }
      }
      setFormItems(form)
      setFirst(false)
    }
  }, [])

  useEffect(() => {
    if (!first) {
      _formType.setFormType(hasFixedFullForm ? 0 : formType)
    }
  }, [formType])

  useEffect(() => {
    if (!first) {
      setFormType(hasFixedFullForm ? 0 : _formType.formType)
    }
  }, [_formType.formType])

  return (
    <div className='modal-header invoice-edit-modal-header'>
      <div className='invoice-edit-modal-header__title'>
        <h2 className='fw-bolder text-primary'>
          <FieldHelpLabel label={title} helpKey='section.header' />
          <span className='ms-2 fs-6 text-gray-400'>
            <span className='fw-bolder'>({currentBusiness?.display || currentCompany?.nm})</span>
          </span>
        </h2>
      </div>
      <div className='invoice-edit-modal-header__actions'>
        <button
          type='button'
          className='btn btn-icon btn-sm btn-active-icon-primary invoice-edit-modal-header__close'
          aria-label='بستن فرم صورتحساب'
          onClick={() => {
            setItemIdForUpdate(undefined)
            setvariableD(undefined)
            if (closeFn) closeFn()
          }}
        >
          <KTIcon iconName='cross' className='fs-1' />
        </button>
        {!hasFixedFullForm && !lockedFullForm && !isSelectingInvoiceType && (
          <div className='invoice-edit-modal-header__form-type-wrap'>
            <select
              className='form-select form-select-solid invoice-edit-modal-header__form-type'
              aria-label='نوع فرم صدور صورتحساب'
              value={formType}
              onChange={(event) => setFormType(Number(event.target.value))}
            >
              {formItems?.map((item) => (
                <option key={item.value} value={item.value} disabled={item.disabled}>
                  {/* A cost-price form the business has no access to says so; picking it shows how to open it. */}
                  {`${item.label}${costFormAccess?.[Number(item.value)] === false ? ' — نیازمند فعال‌سازی' : ''}`}
                </option>
              ))}
            </select>
            <FieldHelpIcon label='نوع فرم' helpKey='ui.formType' />
          </div>
        )}
      </div>
    </div>
  )
}

export {InvoiceEditModalHeader}
